import type { CompanyContactId, Dtos } from "@inrev/common";
import type { AdminPrincipalPreview } from "@portal/api/bond-request/admin/types";
import { createContext } from "react";
import type { AccountIdentity } from "../../../shared/account/AccountHeader";

export type AdminBondRequestSelectedAccount = AccountIdentity & {
	companies: Dtos.Admin.SuretyAccount.Get.Response.Company[];
	metadata?: Dtos.Admin.SuretyAccount.Metadata.Get.Response;
};

export type AdminBondRequestContextValue = {
	principalPreviewsMap: Record<CompanyContactId, AdminPrincipalPreview>;
	filteredPrincipalPreviewsMap: Record<CompanyContactId, AdminPrincipalPreview>;
	selectedAccount: AdminBondRequestSelectedAccount | null;
	setSelectedAccount: (account: AdminBondRequestSelectedAccount | null) => void;
};

export const AdminBondRequestContext = createContext<AdminBondRequestContextValue>(undefined!);
